import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import PageMeta from "@/components/PageMeta";
import { api } from "@/lib/api";

export default function News() {
  const [news, setNews] = useState([]);
  useEffect(() => { api.get("/news").then((r) => setNews(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <PageMeta
        title="News — From the Rink"
        description="Team launches, sponsorship updates, player stories, match highlights and press releases from PSHL8."
        image="/api/og/news/og-image.png"
      />
      <PageHero
        overline="News & Media"
        title={<>From the <span className="text-pshl-electric">Rink.</span></>}
        subtitle="Announcements, team launches, sponsorship updates, player stories, match highlights and press releases."
        bgImage="https://images.pexels.com/photos/6469035/pexels-photo-6469035.jpeg"
      />
      <section className="section pt-0">
        <div className="pshl-container grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {news.map((n) => (
            <Link to={`/news/${n.id}`} key={n.id} data-testid={`news-page-card-${n.id}`} className="group bg-pshl-surface border border-white/10 hover:border-pshl-electric transition-colors overflow-hidden block">
              <div className="h-44 bg-cover bg-center relative" style={{ backgroundImage: `url(${n.image})` }}>
                <div className="absolute inset-0 bg-gradient-to-t from-pshl-surface to-transparent" />
                <span className="absolute top-3 left-3 text-[10px] uppercase tracking-[0.25em] font-display font-semibold bg-pshl-electric text-white px-2 py-1">{n.category}</span>
              </div>
              <div className="p-5">
                <div className="text-[11px] uppercase tracking-[0.22em] text-white/45">{n.date}</div>
                <h3 className="mt-2 font-display text-lg text-white leading-tight group-hover:text-pshl-electric">{n.title}</h3>
                <p className="mt-2 text-sm text-white/70 leading-relaxed">{n.excerpt}</p>
                <div className="mt-4 inline-flex items-center gap-1 text-xs font-display uppercase tracking-[0.18em] text-white/80 group-hover:text-pshl-electric">
                  Read Story <ArrowUpRight className="h-3.5 w-3.5" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
